import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./UserDetailsForm.module.css";
import { useAuth } from "../../hooks/useAuth.js";
import { useCompleteProfileMutation } from "../../store/api/authApi.js";
import Logo from "../../components/Logo.jsx";
import { INTERESTED_FIELDS_OPTIONS } from "../../constants/interestedFields.js";
import { INDIAN_STATES } from "../../constants/states.js";
import { LOOKING_FOR_OPTIONS } from "../../constants/lookingFor.js";
import { toast } from "react-toastify";

const UserDetailsForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    ProfilePhoto: null,
    Name: "",
    DateOfBirth: "",
    ContactNumber: "",
    Gender: "",
    UserType: "",
    RookieType: "",
    Bio: "",
    State: "",
    City: "",
    InterestedFields: [],
    LookingFor: [],
    Video: null,
  });

  const [photoPreview, setPhotoPreview] = useState(null);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [completeProfile] = useCompleteProfileMutation();
  const [otherUserType, setOtherUserType] = useState("");
  const [otherInterestedFields, setOtherInterestedFields] = useState([]);
  const [currentOtherField, setCurrentOtherField] = useState("");
  const [otherLookingFor, setOtherLookingFor] = useState([]);
const [currentOtherLooking, setCurrentOtherLooking] = useState("");
  const { updateProfileStatus } = useAuth();

  useEffect(() => {
    return () => {
      if (photoPreview) URL.revokeObjectURL(photoPreview);
    };
  }, [photoPreview]);
  useEffect(() => {
    const handleClickOutside = () => {
      setShowDropdown(false);
      setShowStateDropdown(false);
      setShowLookingDropdown(false);
    };
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
  const timer = setTimeout(() => {
    setFormData((prev) => ({
      ...prev,
      Name: nameRef.current?.value || prev.Name,
      ContactNumber: contactRef.current?.value || prev.ContactNumber,
      State: stateRef.current?.value || prev.State,
      City: cityRef.current?.value || prev.City,
    }));
  }, 300);

  return () => clearTimeout(timer);
}, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchField, setSearchField] = useState("");
  const [showStateDropdown, setShowStateDropdown] = useState(false);
  const [stateSearch, setStateSearch] = useState("");
  const [showLookingDropdown, setShowLookingDropdown] = useState(false);
  const [searchLooking, setSearchLooking] = useState("");

  const nameRef = useRef(null);
const stateRef = useRef(null);
const cityRef = useRef(null);
const contactRef = useRef(null);

  const filteredFields = INTERESTED_FIELDS_OPTIONS.filter((field) =>
    field.toLowerCase().includes(searchField.toLowerCase()),
  );
  const filteredStates = INDIAN_STATES.filter((state) =>
    state.toLowerCase().includes(stateSearch.toLowerCase()),
  );
  const filteredLooking = LOOKING_FOR_OPTIONS.filter((option) =>
    option.toLowerCase().includes(searchLooking.toLowerCase()),
  );

  const handleLookingForChange = (value) => {
    setFormData((prev) => {
      let updated = [...prev.LookingFor];

      if (updated.includes(value)) {
        updated = updated.filter((v) => v !== value);

       if (value === "Others") {
    setCurrentOtherLooking("");
}
      } else {
        if (updated.length + otherLookingFor.length >= 5) {
          setErrors((prevErr) => ({
            ...prevErr,
            LookingFor: "Maximum 5 selections allowed",
          }));

          return prev;
        }

        updated.push(value);
      }

      return {
        ...prev,
        LookingFor: updated,
      };
    });

    setSearchLooking("");

    if (value === "Others") {
      setOtherLookingFor("");

      setShowLookingDropdown(false);
    }
  };

  const handleInterestedFieldsChange = (value) => {
    setFormData((prev) => {
      let updated = [...prev.InterestedFields];

      if (value === "Others") {
        if (updated.length + otherInterestedFields.length >= 5) return prev;

        if (!updated.includes("Others")) {
          updated.push("Others");

          setCurrentOtherField("");

          setShowDropdown(false);
        }
      } else {
        if (updated.includes(value)) {
          updated = updated.filter((v) => v !== value);
        } else {
          if (updated.length + otherInterestedFields.length >= 5) {
            setErrors((prevErr) => ({
              ...prevErr,
              InterestedFields: "Maximum 5 fields allowed",
            }));

            return prev;
          }

          updated.push(value);
        }
      }

      return {
        ...prev,
        InterestedFields: updated,
      };
    });

    setSearchField("");
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith("image/")) {
        setErrors((prev) => ({
          ...prev,
          ProfilePhoto: "Please upload a valid image file",
        }));
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        setErrors((prev) => ({
          ...prev,
          ProfilePhoto: "File size must be less than 5MB",
        }));
        return;
      }
      setPhotoPreview(URL.createObjectURL(file));
      setFormData((prev) => ({ ...prev, ProfilePhoto: file }));
      setErrors((prev) => ({ ...prev, ProfilePhoto: "" }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.Name.trim()) newErrors.Name = "Full Name is required";
    if (formData.ContactNumber && !formData.ContactNumber.match(/^\d{10}$/))
      newErrors.ContactNumber = "Enter a valid 10-digit mobile number";
    if (!formData.UserType) newErrors.UserType = "User Type is required";
    if (!formData.Gender) newErrors.Gender = "Gender is required";
    if (!formData.State.trim()) newErrors.State = "State is required";
    if (formData.UserType === "Rookie" && !formData.RookieType)
      newErrors.RookieType = "Please select your role";
    if (formData.UserType === "Others" && !otherUserType.trim()) {
      newErrors.UserType = "Please specify your user type";
    }
    if (
      formData.InterestedFields.includes("Others") &&
      otherInterestedFields.length === 0
    ) {
      newErrors.InterestedFields = "Add at least one custom interested field";
    }

   if (
    formData.LookingFor.includes("Others") &&
    otherLookingFor.length === 0
) {
    newErrors.LookingFor =
        "Add at least one custom Looking For option";
}
    if (!formData.InterestedFields.length)
      newErrors.InterestedFields = "Interested Fields is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    const finalUserType =
      formData.UserType === "Others" ? otherUserType.trim() : formData.UserType;
    setIsSubmitting(true);
    try {
      let finalInterestedFields = formData.InterestedFields.filter(
        (x) => x !== "Others",
      );

      finalInterestedFields = [
        ...finalInterestedFields,
        ...otherInterestedFields,
      ];

      let finalLookingFor = formData.LookingFor.filter(
    (x) => x !== "Others"
);

finalLookingFor = [
    ...finalLookingFor,
    ...otherLookingFor,
];
      const apiData = new FormData();
      const fieldMap = {
        Name: "Name",
        DateOfBirth: "DateOfBirth",
        ContactNumber: "ContactNumber",
        Gender: "Gender",
        //UserType: "UserType",
        RookieType: "RookieType",
        Bio: "Bio",
        State: "State",
        City: "City",
      };
      Object.entries(fieldMap).forEach(([key, apiKey]) => {
        if (formData[key] !== null && formData[key] !== "") {
          apiData.append(apiKey, formData[key]);
        }
      });
      apiData.append("UserType", finalUserType);

      // ✅ always append interested fields
      apiData.append("InterestedFields", finalInterestedFields.join(","));
      apiData.append("LookingFor", finalLookingFor.join(","));
      if (formData.ProfilePhoto instanceof File)
        apiData.append("ProfilePhoto", formData.ProfilePhoto);
      if (formData.Video instanceof File)
        apiData.append("Video", formData.Video);

      const response = await completeProfile(apiData);
      if (response.error)
        throw new Error(
          response.error?.data?.message || "Profile update failed",
        );

      toast.success("Profile completed successfully!");
      updateProfileStatus(true);
      navigate("/");
    } catch (error) {
      setErrors({
        submit:
          error.message || "Failed to complete profile. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

 const filledCount = [
  !!formData.ProfilePhoto,
  !!formData.Name.trim(),
  !!formData.DateOfBirth,
  !!formData.ContactNumber.trim(),
  !!formData.Gender,
  !!formData.UserType,
  !!formData.State.trim(),
  !!formData.City.trim(),
  formData.InterestedFields.length > 0,
  formData.LookingFor.length > 0,
  !!formData.Bio.trim(),
].filter(Boolean).length;

const totalFields = 11;
const progress = Math.min(
  100,
  Math.round((filledCount / totalFields) * 100)
);

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        {/* ── Left brand panel ── */}
        <div className={styles.brandPanel}>
          <div className={styles.brandInner}>
            <div className={styles.logo}>
              <Logo height={300} scale={1.5} />
            </div>

            {/* Avatar preview */}
            <div className={styles.avatarWrap}>
              <label htmlFor="profilePhoto" className={styles.avatarLabel}>
                <div className={styles.avatarRing}>
                  {photoPreview ? (
                    <img
                      src={photoPreview}
                      alt="Profile"
                      className={styles.avatarImg}
                    />
                  ) : (
                    <span className={styles.avatarPlaceholder}>+</span>
                  )}
                  <div className={styles.avatarEdit}>✎</div>
                </div>
                <p className={styles.avatarHint}>Upload photo</p>
              </label>
              <input
                type="file"
                accept="image/*"
                id="profilePhoto"
                onChange={handlePhotoChange}
                className={styles.hiddenFileInput}
              />
              {errors.ProfilePhoto && (
                <span className={styles.fieldError}>{errors.ProfilePhoto}</span>
              )}
            </div>

            {/* Progress */}
            <div className={styles.progressWrap}>
              <div className={styles.progressRow}>
                <span className={styles.progressLabel}>Profile completion</span>
                <span className={styles.progressPct}>{progress}%</span>
              </div>
              <div className={styles.progressBar}>
                <div
                  className={styles.progressFill}
                  style={{ width: `${progress}%` }}
                />
              </div>
            </div>

            <div className={styles.brandDots}>
              <span className={styles.dot} />
              <span className={styles.dot} />
              <span className={styles.dot} />
            </div>
          </div>
        </div>

        {/* ── Right form panel ── */}
        <div className={styles.formPanel}>
          <div className={styles.formInner}>
            <div className={styles.formHeader}>
              <h2 className={styles.heading}>Complete Your Profile</h2>
              <p className={styles.subheading}>
                Tell us a bit about yourself to personalise your experience
              </p>
            </div>

            {errors.submit && (
              <p className={styles.errorBanner}>{errors.submit}</p>
            )}

            <form onSubmit={handleSubmit} noValidate>
              <div className={styles.formGroup}>
                {/* Name & DOB */}
                <div className={styles.row}>
                  <div className={styles.fieldGroup}>
                    <label htmlFor="Name" className={styles.label}>
                      Full Name <span className={styles.req}>*</span>
                    </label>
                    <input
                    ref={nameRef}
                      type="text"
                      id="Name"
                      name="Name"
                      placeholder="Your full name"
                      value={formData.Name}
                      onChange={handleChange}
                      onInput={handleChange}
                      className={`${styles.input} ${errors.Name ? styles.inputError : ""}`}
                    />
                    {errors.Name && (
                      <span className={styles.fieldError}>{errors.Name}</span>
                    )}
                  </div>

                  <div className={styles.fieldGroup}>
                    <label htmlFor="DateOfBirth" className={styles.label}>
                      Date of Birth
                    </label>
                    <input
                      type="date"
                      id="DateOfBirth"
                      name="DateOfBirth"
                      value={formData.DateOfBirth}
                      onChange={handleChange}
                      className={styles.input}
                    />
                  </div>
                </div>

                {/* Mobile & Gender */}
                <div className={styles.row}>
                  <div className={styles.fieldGroup}>
                    <label htmlFor="ContactNumber" className={styles.label}>
                      Mobile Number
                    </label>
                    <input
                    ref={contactRef}
                      type="tel"
                      id="ContactNumber"
                      name="ContactNumber"
                      placeholder="10-digit number"
                      value={formData.ContactNumber}
                      onChange={handleChange}
                      className={`${styles.input} ${errors.ContactNumber ? styles.inputError : ""}`}
                    />
                    {errors.ContactNumber && (
                      <span className={styles.fieldError}>
                        {errors.ContactNumber}
                      </span>
                    )}
                  </div>

                  <div className={styles.fieldGroup}>
                    <label htmlFor="Gender" className={styles.label}>
                      Gender <span className={styles.req}>*</span>
                    </label>
                    <select
                      id="Gender"
                      name="Gender"
                      value={formData.Gender}
                      onChange={handleChange}
                      className={styles.input}
                    >
                      <option value="">Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                </div>

                {/* State & Interested Fields */}
                <div className={styles.row}>
                  <div className={styles.fieldGroup}>
                    <label htmlFor="State" className={styles.label}>
                      State <span className={styles.req}>*</span>
                    </label>
                    <div className={styles.dropdownWrapper}>
                      <div
                        className={`${styles.multiInput} ${errors.State ? styles.inputError : ""}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowStateDropdown(true);
                        }}
                      >
                        <input
                        ref={stateRef}
                          type="text"
                          placeholder="Select State"
                          value={stateSearch}
                          onInput={handleChange}
                          onChange={(e) => {
                            setStateSearch(e.target.value);
                            setShowStateDropdown(true);

                            setFormData((prev) => ({ ...prev, State: "" }));
                          }}
                          className={styles.searchInput}
                        />

                        <span className={styles.selectArrow}></span>
                      </div>

                      {showStateDropdown && (
                        <div className={styles.dropdownList}>
                          {filteredStates.map((state) => (
                            <div
                              key={state}
                              className={styles.dropdownItem}
                              onClick={() => {
                                setFormData((prev) => ({
                                  ...prev,
                                  State: state,
                                }));
                                setStateSearch(state);
                                setShowStateDropdown(false);
                              }}
                            >
                              {state}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    {errors.State && (
                      <span className={styles.fieldError}>{errors.State}</span>
                    )}
                  </div>

                  <div className={styles.fieldGroup}>
                    <label htmlFor="City" className={styles.label}>
                      City
                    </label>

                    <input
                    ref={cityRef}
                      type="text"
                      id="City"
                      name="City"
                      placeholder="Enter your city"
                      onInput={handleChange}
                      value={formData.City}
                      onChange={handleChange}
                      onInput={handleChange}
                      className={styles.input}
                    />
                  </div>
                </div>

                <div className={styles.row}>
                  <div className={styles.fieldGroup}>
                    <label className={styles.label}>
                      Interested Fields <span className={styles.req}>*</span>
                    </label>

                    <div className={styles.dropdownWrapper}>
                      <div
                        className={`${styles.multiInput} ${errors.InterestedFields ? styles.inputError : ""}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowDropdown(true);
                        }}
                      >
                        {[
                          ...formData.InterestedFields.filter(
                            (x) => x !== "Others",
                          ),
                          ...otherInterestedFields,
                        ].map((field) => (
                          <span key={field} className={styles.tag}>
                            {field}
                            <span
                              className={styles.removeTag}
                              onClick={(e) => {
                                e.stopPropagation();
                                if (otherInterestedFields.includes(field)) {
                                  setOtherInterestedFields(
                                    otherInterestedFields.filter(
                                      (x) => x !== field,
                                    ),
                                  );
                                } else {
                                  handleInterestedFieldsChange(field);
                                }
                              }}
                            >
                              ×
                            </span>
                          </span>
                        ))}

                        <input
                          type="text"
                          placeholder="Select up to 5 fields..."
                          value={searchField}
                          onChange={(e) => {
                            setSearchField(e.target.value);
                            setShowDropdown(true);
                          }}
                          className={styles.searchInput}
                        />

                        <span className={styles.selectArrow}></span>
                      </div>

                      {showDropdown && (
                        <div className={styles.dropdownList}>
                          {filteredFields.map((field) => (
                            <div
                              key={field}
                              className={`${styles.dropdownItem} ${
                                formData.InterestedFields.includes(field)
                                  ? styles.selectedItem
                                  : ""
                              }`}
                              onClick={() =>
                                handleInterestedFieldsChange(field)
                              }
                            >
                              {field}
                            </div>
                          ))}

                          {filteredFields.length === 0 && (
                            <div className={styles.noResult}>
                              No results found
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                    {errors.InterestedFields && (
                      <span className={styles.fieldError}>
                        {errors.InterestedFields}
                      </span>
                    )}
                    {formData.InterestedFields.includes("Others") && (
                      <div className={styles.fieldGroup}>
                        <input
                          type="text"
                          placeholder="Enter interested field"
                          value={currentOtherField}
                          onChange={(e) => setCurrentOtherField(e.target.value)}
                          className={styles.input}
                        />

                        <button
                          type="button"
                          className={styles.button}
                          style={{ marginTop: "8px" }}
                          onClick={() => {
                            if (
                              currentOtherField.trim() &&
                              formData.InterestedFields.length +
                                otherInterestedFields.length <
                                5
                            ) {
                              setOtherInterestedFields([
                                ...otherInterestedFields,
                                currentOtherField.trim(),
                              ]);

                              setCurrentOtherField("");
                            }
                          }}
                        >
                          Add
                        </button>
                      </div>
                    )}
                  </div>

                  <div className={styles.fieldGroup}>
                    <label className={styles.label}>Looking For</label>

                    <div className={styles.dropdownWrapper}>
                      <div
                        className={styles.multiInput}
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowLookingDropdown(true);
                        }}
                      >
                        {[
    ...formData.LookingFor.filter((x) => x !== "Others"),
    ...otherLookingFor,
].map((item) => (
                          <span key={item} className={styles.tag}>
                            {item}
                            <span
                              className={styles.removeTag}
                              onClick={(e) => {
                                e.stopPropagation();
                                if (otherLookingFor.includes(item)) {
    setOtherLookingFor(
        otherLookingFor.filter((x) => x !== item)
    );
} else {
    handleLookingForChange(item);
}
                              }}
                            >
                              ×
                            </span>
                          </span>
                        ))}

                        <input
                          type="text"
                          placeholder="Select options..."
                          value={searchLooking}
                          onChange={(e) => {
                            setSearchLooking(e.target.value);
                            setShowLookingDropdown(true);
                          }}
                          className={styles.searchInput}
                        />

                        <span className={styles.selectArrow}></span>
                      </div>

                      {showLookingDropdown && (
                        <div className={styles.dropdownList}>
                          {filteredLooking.map((option) => (
                            <div
                              key={option}
                              className={`${styles.dropdownItem} ${
                                (formData.LookingFor || []).includes(option)
                                  ? styles.selectedItem
                                  : ""
                              }`}
                              onClick={() => handleLookingForChange(option)}
                            >
                              {option}
                            </div>
                          ))}
                        </div>
                      )}
                     {formData.LookingFor.includes("Others") && (
    <div className={styles.fieldGroup}>
        <input
            type="text"
            placeholder="Enter what you're looking for"
            value={currentOtherLooking}
            onChange={(e) =>
                setCurrentOtherLooking(e.target.value)
            }
            className={styles.input}
        />

        <button
            type="button"
            className={styles.button}
            style={{ marginTop: "8px" }}
            onClick={() => {
                if (
                    currentOtherLooking.trim() &&
                    formData.LookingFor.length +
                        otherLookingFor.length <
                        5
                ) {
                    setOtherLookingFor([
                        ...otherLookingFor,
                        currentOtherLooking.trim(),
                    ]);

                    setCurrentOtherLooking("");
                }
            }}
        >
            Add
        </button>
    </div>
)}
                    </div>
                  </div>
                </div>
                {/* User Type */}
                <div className={styles.fieldGroup}>
                  <label htmlFor="UserType" className={styles.label}>
                    User Type <span className={styles.req}>*</span>
                  </label>
                  <select
                    id="UserType"
                    name="UserType"
                    value={formData.UserType}
                    onChange={handleChange}
                    className={`${styles.input} ${errors.UserType ? styles.inputError : ""}`}
                  >
                    <option value="" disabled>
                      Select user type
                    </option>
                    <option value="Rookie">Rookie</option>
                    <option value="Entrepreneur">Entrepreneur</option>
                    <option value="Business Professional">
                      Business Professional
                    </option>
                    <option value="Investor">Investor</option>
                    <option value="Freelancer">Freelancer</option>
                    <option value="Mentor">Mentor</option>
                    <option value="Others">Others</option>
                  </select>
                  {errors.UserType && (
                    <span className={styles.fieldError}>{errors.UserType}</span>
                  )}
                </div>
                {formData.UserType === "Others" && (
                  <div className={styles.fieldGroup}>
                    <input
                      type="text"
                      placeholder="Enter your user type"
                      value={otherUserType}
                      onChange={(e) => setOtherUserType(e.target.value)}
                      className={styles.input}
                    />
                  </div>
                )}
                {/* Rookie type */}
                {formData.UserType === "Rookie" && (
                  <div className={styles.fieldGroup}>
                    <label htmlFor="RookieType" className={styles.label}>
                      I am a… <span className={styles.req}>*</span>
                    </label>
                    <select
                      id="RookieType"
                      name="RookieType"
                      value={formData.RookieType}
                      onChange={handleChange}
                      className={`${styles.input} ${errors.RookieType ? styles.inputError : ""}`}
                    >
                      <option value="" disabled>
                        Select one
                      </option>
                      <option value="Student">Student</option>
                      <option value="Working Professional">
                        Working Professional
                      </option>
                      <option value="Others">Others</option>
                    </select>
                    {errors.RookieType && (
                      <span className={styles.fieldError}>
                        {errors.RookieType}
                      </span>
                    )}
                  </div>
                )}

                {/* Bio */}
                <div className={styles.fieldGroup}>
                  <label htmlFor="Bio" className={styles.label}>
                    Bio
                  </label>
                  <textarea
                    id="Bio"
                    name="Bio"
                    placeholder="Tell us about yourself…"
                    value={formData.Bio}
                    onChange={handleChange}
                    rows={4}
                    className={`${styles.input} ${styles.textarea} ${errors.Bio ? styles.inputError : ""}`}
                  />
                  {errors.Bio && (
                    <span className={styles.fieldError}>{errors.Bio}</span>
                  )}
                </div>

                <button
                  type="submit"
                  className={styles.button}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Saving Profile…" : "Complete Profile"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetailsForm;
